module.exports = __webpack_public_path__ + "img/7.c8a865ee.jpg";